export enum GameStatus {
  Ready = 'READY',
  InProgress = 'IN PROGRESS',
  Complete = 'COMPLETE',
  Abandoned = 'ABANDONED',
}
